import React, { useContext } from 'react';

import { EventsApi } from '../apis';
import { api } from '../api';

const EventsApiContext = React.createContext(new EventsApi(api));

export const EventsApiProvider = EventsApiContext.Provider;
export const useEventsApi = (): EventsApi => useContext(EventsApiContext);
